<template>
	<div class="special">
		<!-- header -->
		<!-- <div class="special.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="special.block">
			<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="special.bread" data-aos="fade-left">
			<Bread :currentPage="{name:'特价商城',path:'/Special'}"/>
		</div>
		<div class="special.container">
			<div class="special.item" data-aos="fade-right">
				<img src="../assets/trademarks/trade-head.jpg" alt="">
			</div>
			<div class="special.item +content-box">
				<section>
					<!-- 筛选菜单 -->
					<!-- <SelectMenus :menus="specialMenus" :allMenus="specialMenus" data-aos="fade-right"></SelectMenus> -->
					<special-menu @updateSpecial="updateSpecial"></special-menu>
					<!-- 筛选时间和价格 -->
					<select-tabs :isSelect="isSelect" :selectTabs="{type:'',account:account}" data-aos="fade-right" @searchEvent="searchEvent" @priceSortEvent="priceSortEvent" @timeSortEvent="timeSortEvent"></select-tabs>
					<!-- 筛选得内容 -->
					<select-lists :lists="copyRightData" :pageParams="pageParams" @updateLists="updateLists" :pageSize="isSelect ? 16 : 10"></select-lists>
				</section>
				<section>
					<div class="special.propaganda" data-aos="fade-left">
						<button @click="showConsultationEvent">更多特价 免费咨询</button>
					</div>
				</section>
			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
		<consultation-modal :consultationShow="consultationShow" @closeConsultationEvent="closeConsultationEvent"></consultation-modal>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'
	import SelectMenus from '../components/select-menus.vue'
	import SelectTabs from "../components/select-tabs.vue"
	import SelectLists from '../components/select-lists.vue'
	import CopyRightSigin from '../components/copy-right-sigin.vue'
	import ConsultationModal from '../components/consultation-modal.vue'
	import SpecialMenu from '../components/special-menu.vue'
	
	export default{
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,
			SelectMenus,
			SelectTabs,
			SelectLists,
			CopyRightSigin,
			ConsultationModal,
			SpecialMenu
		
		},
		data(){
			return{
				pageParams:{
					totalMCount: 0,
					pageMNo: 1,
				},
				priceSort:'',
				timeSort:'',
				isSelect:true,
				account:0,
				isTrademark:false,
				consultationShow:false,
				specialType:'商标',
				searchVal:'',
				specialApiurl:'IPR_Trademark',
				specialMenus: [{                                
						type: '特价类型',
						lists: [{
							name: '商标'
						}, {
							name: '版权'
						}, {
							name: '专利'
						}],
						isShowBtn: false,
				}],

				copyRightLists:[
					{title:'SEBE 拾贝',desc:'让创新保护，不再困难',icon:require('../assets/trademarks/list-test.png'),priceDesc:'￥35100',type:'版权',id:0},
				]
			}
		},
		methods:{
			closeConsultationEvent(val){
				this.consultationShow = val
			},
			showConsultationEvent(val){
				this.consultationShow = val
			},
			toggleTrademarks(val){
				this.isTrademark = val
			},
			initSpecial(page,apiUrl){
				page = page ? page : 1
				this.specialApiurl = apiUrl;
				if(apiUrl == 'IPR_Copyright'){
					this.specialType = '版权'
				}else if(apiUrl == 'IPR_Patent'){
					this.specialType = '专利'
				}else{
					this.specialType = '商标'
				}
				this.http.get(`${apiUrl}?is_special=2&page=${page}&price=${this.priceSort}&check_time=${this.timeSort}`).then(res => {
					//console.log(res.data.data)
					this.copyRightLists = res.data.data
					this.pageParams.totalMCount = res.data.total
					this.account = res.data.total
				})
			},
			searchSpecial(){
				let url = '';
				if(this.isSelect){
					url = `${this.specialApiurl}?name=${this.searchVal}&is_special=2&price=${this.priceSort}&check_time=${this.timeSort}`
				}else{
					url = `${this.specialApiurl}?search=${this.searchVal}`
				}
				this.http.get(url).then(res => {
					this.copyRightLists = res.data.data
					this.pageParams.totalMCount = res.data.total
					this.account = res.data.total
				
				})
			},
			updateLists(val) {
				this.initSpecial(val,this.specialApiurl)
			},
			updateSpecial(apiUrl){
				
				this.isSelect = apiUrl == 'IPR_Patent' ? false : true
				if(apiUrl == 'IPR_Patent'){
					this.copyRightLists = []
					this.account = 0
				}else{
					this.initSpecial(1,apiUrl);
				}
				
				
			},
			searchEvent(keyValue){
				this.searchVal = keyValue
				this.searchSpecial()
			},
			priceSortEvent(type){
				this.priceSort = type.priceType
				this.timeSort= type.timeType
				this.searchSpecial()
			},
			timeSortEvent(type){
				this.priceSort = type.priceType
				this.timeSort= type.timeType
				this.searchSpecial()
			}
		},
		computed:{
			copyRightData(){
				return this.copyRightLists.map(({
					name,
					image,
					description,
					id,
					price
				}) => {
					return {
						title: name,
						icon: image ? this.imgUrl + image : require("../assets/empty.png"),
						desc: description,
						id: id,
						type:this.specialType,
						priceDesc:price
					}
				})
			}
		},
		mounted(){
			this.initSpecial(1,'IPR_Trademark')
		}
	}
</script>

<style lang="scss">
	@include component(special){
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}
		@include part(bread){
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}
		@include part(container){
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			
		}
		@include part(item){
			width: 1200px;
			margin: 0 auto;
			padding-top: 18px;
			padding-bottom: 18px;
		}
		@include tweak(content-box){
			display: flex;
			justify-content: space-between;
			section{
				
				&:nth-child(1){
					width:940px;
	
				}
				&:nth-child(2){
					width:240px;
				}
			}
		}
		@include part(propaganda){
			width: 100%;
			height: 640px;
			box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.2);
			background: url('../assets/tejia/bg.jpg');
			display: flex;
			justify-content: center;
			align-items: flex-end;
			padding-bottom: 30px;
			button{
				width:190px;
				height:50px;
				background:linear-gradient(90deg,rgba(255,155,0,1) 0%,rgba(254,191,0,1) 100%);
				box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.2);
				border-radius:5px;
				color: #FFFFFF;
				border: none;
				outline: none;
				font-weight: bold;
				cursor: pointer;
			}
			
		}
	}
</style>
